import { render } from "./imagePick.vue?vue&type=template&id=fa898836&scoped=true&lang=pug"
import script from "./imagePick.vue?vue&type=script&setup=true&lang=js"
export * from "./imagePick.vue?vue&type=script&setup=true&lang=js"

import "./imagePick.vue?vue&type=style&index=0&id=fa898836&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa898836"]])

export default __exports__